// extracted by mini-css-extract-plugin
export default {"timeline":"InstitutionTimeline_timeline__Qh8MB","item":"InstitutionTimeline_item__UExN7","itemTitle":"InstitutionTimeline_itemTitle__yA9Pc"};